import { useQuery } from "@apollo/client";
import { GetAppSettingsQuery } from "gql/graphql";
import { ReactNode, createContext, useContext } from "react";
import { APPLICATION_SETTINGS } from "./api/get-application-settings/get-application-settings";
import { SupportedLanguagesToLocale } from "@/shared/i18n/utils/supported-languages-to-locale";
import useLocale from "../../../shared/i18n/model/use-locale";
import { Locale } from "@/shared/i18n/config";

type ContextProps = GetAppSettingsQuery["getApplicationSettings"];

export const ApplicationSettingsContext = createContext<ContextProps>(
  {} as ContextProps,
);

export function ApplicationSettingsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { locale, setLocale } = useLocale();
  const { data } = useQuery(APPLICATION_SETTINGS, {
    onCompleted: (res) => {
      if (locale) {
        return;
      }
      const baseLocale = res?.getApplicationSettings.languages.at(0);
      if (!baseLocale) {
        return;
      }
      setLocale(SupportedLanguagesToLocale[baseLocale] as Locale);
    },
  });

  if (!data) return null;

  return (
    <ApplicationSettingsContext.Provider value={data.getApplicationSettings}>
      {children}
    </ApplicationSettingsContext.Provider>
  );
}

export function useApplicationSettings() {
  return useContext(ApplicationSettingsContext);
}
